import React, { Component } from 'react';
import './StartScreen.css';
import { withTranslation } from "react-i18next";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

class StartScreen extends Component {


    render() {
        const { t } = this.props;

        return (
            <Box className="StartScreen">
                <h1>{t('Wideoweryfikacja')}</h1>
                <p>
                    <span>{t('W celu przeprowadzenia wideoweryfikacji')} </span>
                    <strong>{t('przygotuj dokument tożsamości.')} </strong>
                    <span>{t('Podczas wideoweryfikacji należy przestrzegać kilku zasad')}:</span>
                </p>
                <ul>
                    <li>{t('Wideoweryfikacji należy dokonać samodzielnie, bez udziału osób trzecich.')}</li>
                    <li>{t('Podczas wideoweryfikacji zostanie wyświetlony komunikat z prośbą o okazanie dokumentu tożsamości użytego podczas rejestracji.')}</li>
                    <li>{t('Prosimy o ustawienie telefonu lub komputera stabilnie w jednym miejscu i nieporuszanie ekranem podczas przeprowadzania wideoweryfikacji.')}</li>
                    <li>{t('Dokument pokazywany podczas wideoweryfikacji musi być widoczny na ekranie na tyle, żeby można było odczytać szczegóły.')}</li>
                </ul>
                <p>{t('Jeżeli jesteś gotowy naciśnij start.')}</p>
                <Button
                    variant="contained"
                    onClick={this.props.handleStartButtonClick}
                    style={{
                        fontSize: "40px",
                    }}
                    size="large"
                    color="warning"
                >
                    {t('Start')}
                </Button>
            </Box>
        );
    }
}

export default withTranslation()(StartScreen);